<template>
  <b-container>
    <b-row>
      <b-col sm="12" md="6" lg="6">
        <b-form-group
          :label="$t('tracking.cargoExpenseOccurrence.model.sequenceNumber')"
          label-for="sequenceNumber"
        >
          <base-input-integer
            id="sequencNumber"
            :placeholder="
              $t('tracking.cargoExpenseOccurrence.model.sequenceNumber')
            "
            :value.sync="model.sequenceNumber"
            :readonly="readonly"
          >
          </base-input-integer>
        </b-form-group>
        <b-form-group
          :label="$t('tracking.cargoExpenseOccurrence.model.description')"
          label-for="description"
        >
          <b-form-input
            id="descripton"
            type="text"
            :placeholder="
              $t('tracking.cargoExpenseOccurrence.model.description')
            "
            v-model="model.description"
            :readonly="readonly"
          />
          <span class="text-danger" v-if="modelstate['Description']">
            {{ modelstate["Description"][0] }}
          </span>
        </b-form-group>
        <b-form-group
          label="Controle de validação"
          label-for="description"
        >
          <b-form-select
            v-model="model.validateControl"
            id="perPageSelect"
            :options="validateControlOptions"
          ></b-form-select>
        </b-form-group>

        <b-form-group
          label="Dias limite kanban"
          label-for="sequenceNumber"
        >
          <base-input-integer
            id="sequencNumber"
            placeholder="Dias limete que ficrá visivel no kanban"
            :value.sync="model.kanbanLimitDays"
            :readonly="readonly"
          >
          </base-input-integer>
        </b-form-group>

      </b-col>
    </b-row>
  <!-- {{model}} -->
    <b-row>
      <b-col>
        
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12" lg="12">
        <h4>Campos customizados</h4>
        <custom-fields ref="customField" :items="model.customFields">
        </custom-fields>
      </b-col>
      <!-- {{model.customFields}} -->
      <!-- {{ customFields.customFields }} -->
    </b-row>
    <b-row>
      <b-col sm="12" md="6" lg="6">
        <div class="mt-2">
          <h4>{{ $t("tracking.cargoExpenseOccurrence.profiles") }}</h4>

          <div
            class="form-group"
            v-for="row in model.profiles"
            :key="row.profilesId"
          >
            <b-row>
              <b-col md="4">
                <label class="pt-2">{{ row.profileName }}</label>
              </b-col>

              <b-col>
                <cargo-expense-permissions-dropdown
                  :value.sync="row.permissions"
                >
                </cargo-expense-permissions-dropdown>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
    <!-- <div>{{model}}</div> -->
  </b-container>
</template>

<script>
import BaseInputInteger from "@/components_rms/base/BaseInputInteger.vue";
import CargoExpensePermissionsDropdown from "@/components_rms/trackingShippingCompany/cargoExpense/CargoExpensePermitionsDropdown.vue";

import CustomFields from "@/components_rms/trackingShippingCompany/cargoExpense/CustomFields.vue";
export default {
  name: "CargoExpenseOccurrenceCrudData",
  directives: {},
  components: {
    BaseInputInteger,
    CargoExpensePermissionsDropdown,
    CustomFields,
  },
  props: {
    model: Object,
    modelstate: Object,
    readonly: Boolean,
  },
  data() {
    return {
      editField: false,
      validateControlOptions: [
        { value: 0, text: "Nenhum" },
        { value: 1, text: "Não duplicar" },
        { value: 2, text: "Valor" },
      ],
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
  watch: {
    model() {
      this.$forceUpdate();
    },
  },
};
</script>
<style scoped>
.btn_customField {
  margin-left: 50%;
  margin-top: -35px !important;
  width: auto;
  height: 30px;
}
.customValue {
  margin-left: 1%;
}
</style>
